import type { ReactNode } from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ImageIcon from "@mui/icons-material/Image";
import type { FormatCategory } from "../types";

export type FormatTogglesProps = {
  value: FormatCategory[];
  onChange: (next: FormatCategory[]) => void;
};

const OPTIONS: { value: FormatCategory; icon: ReactNode; label: string }[] = [
  { value: "pdf", icon: <PictureAsPdfIcon />, label: "PDF" },
  { value: "image", icon: <ImageIcon />, label: "image" },
];

export const FormatToggles = ({ value, onChange }: FormatTogglesProps) => (
  <Box sx={{ display: "flex", gap: 0.5 }}>
    {OPTIONS.map((opt) => {
      const selected = value.includes(opt.value);
      const title = `${selected ? "Hide" : "Show"} ${opt.label}s`;
      return (
        <Tooltip key={opt.value} title={title}>
          <IconButton
            color={selected ? "primary" : "default"}
            onClick={() =>
              onChange(
                selected
                  ? value.filter((v) => v !== opt.value)
                  : [...value, opt.value],
              )
            }
            aria-label={`${opt.label} filter: ${selected ? "on" : "off"}`}
            sx={{ p: 1, opacity: selected ? 1 : 0.55 }}
          >
            {opt.icon}
          </IconButton>
        </Tooltip>
      );
    })}
  </Box>
);
